import { ReactComponent as SearchLicenceTabIconSvg } from "./icon_tab_search-licence.svg";

const SearchLicenceTabIcon = (props) => {
  return <SearchLicenceTabIconSvg {...props} />;
};

export default SearchLicenceTabIcon;
